// src/components/About.js
import React from 'react';

const About = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>We are dedicated to helping you explore the wonders of Sri Lanka.</p>
    </div>
  );
};

export default About;
